import { render } from "./bi_model.vue?vue&type=template&id=3875ae74&scoped=true"
import script from "./bi_model.vue?vue&type=script&lang=js"
export * from "./bi_model.vue?vue&type=script&lang=js"

import "./bi_model.vue?vue&type=style&index=0&id=3875ae74&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3875ae74"]])

export default __exports__